import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { parseEntityPath } from '@ruta/shared';
import { resolveEntityRoute } from '@/lib/entityRoutes';

/**
 * Handles canonical entity paths (e.g. /crews/:id, /conversations/:id) by
 * resolving them to the correct internal webapp route.
 *
 * Visits are handled by the dedicated VisitRedirect — a visit needs an extra
 * customer lookup. These canonical URLs are used in notifications so they can
 * also be intercepted by the mobile app via universal links.
 */
export function EntityPathRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const ref = parseEntityPath(location.pathname);
    if (ref) {
      const route = resolveEntityRoute(ref);
      if (route) {
        navigate(route, { replace: true });
        return;
      }
    }
    navigate('/assistant', { replace: true });
  }, [location.pathname, navigate]);

  return null;
}
